import React, { useEffect, useState } from "react";
import "./news.scss";
import { baseUrl } from "../../../constants/constants";
import OneNews from "./components/oneNews";
import { Helmet } from "react-helmet-async";
import Logo from "../../../assets/logo.jpg";

const href =
    typeof window !== "undefined" ? window.location.href : "https://нцпти.рф/";

export interface INewsPublic {
    id: number;
    name: string;
    description: string;
    source_link: string;
    image_url: string;
    create_date: Date;
    dzen_link: string;
    tg_link: string;
    tags: ITags[];
}

export interface ITags {
    id: number;
    name: string;
}

export interface ImageTitleInterface {
    id: number;
    category_name: string;
    file_url: string;
    category_id: number;
}

const News = () => {
    const [news, setNews] = useState<INewsPublic[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [disabled, setDisabled] = useState(false);
    const [tags, setTags] = useState<ITags[]>([]);
    const [image, setImage] = useState<ImageTitleInterface[]>([]);
    const [mobileImage, setMobileImage] = useState<ImageTitleInterface>();
    const [showAll, setShowAll] = useState(false);
    const [selectedTag, setSelectedTag] = useState<{ id: number; name: string } | null>(null);

    const mainTags = 2;
    const pageSize = 10;

    const getNewsUrl = () => {
        let url = `${baseUrl}news?page=${currentPage}&page_size=${pageSize}&sort_date=true`;
        if (selectedTag) {
            url += `&tag_id=${selectedTag.id}`;
        }
        return url;
    };

    useEffect(() => {
        fetch(getNewsUrl())
            .then((res) => res.json())
            .then((data) => {
                const newsArray = Array.isArray(data) ? data : data.results || [];

                if (currentPage === 1) {
                    setNews(newsArray);
                } else {
                    setNews((prevNews) => [...prevNews, ...newsArray]);
                }
            })
            .catch((err) => {
                console.error(err);
                setNews([]);
            });

        fetch(`${baseUrl}tags`)
            .then((result) => result.json())
            .then((tegi) => {
                setTags(tegi);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentPage, selectedTag]);

    useEffect(() => {
        fetch(getNewsUrl() + `&page=${currentPage + 1}`)
            .then((res) => res.json())
            .then((data) => {
                if (data.length === 0) {
                    setDisabled(true);
                } else {
                    setDisabled(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentPage, selectedTag]);

    useEffect(() => {
        if (tags.length > 0 && !selectedTag) {
            const defaultTag = tags.find(tag => tag.name === "Новости недели");
            if (defaultTag) {
                setSelectedTag({ id: defaultTag.id, name: defaultTag.name });
            }
        }
    }, [tags]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedTag]);

    useEffect(() => {
        fetch(`${baseUrl}gallery_images?category_id=16`)
            .then((res) => res.json())
            .then((data) => {
                setImage(data);
            })
            .catch((err) => {
                console.log(err);
            });

        fetch(`${baseUrl}gallery_images/90`)
            .then((res) => res.json())
            .then((data) => {
                setMobileImage(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const handleTagClick = (tag: ITags) => {
        setSelectedTag(prev => (prev && prev.id === tag.id ? null : { id: tag.id, name: tag.name }));
    };

    const filteredNews = selectedTag
        ? news.filter((item) =>
            item.tags.some((tag) => tag.id === selectedTag.id)
        )
        : news;

    return (
        <>
            <Helmet>
                <title>Новости | НЦПТИ</title>
                <meta
                    name="description"
                    content="Анонсы событий, новостей, конкурсов, мероприятий, и образовательных курсов от команды НЦПТИ"
                />
                <meta property="og:title" content="Новости | НЦПТИ" />
                <meta
                    property="og:description"
                    content="Анонсы событий, новостей, конкурсов, мероприятий, и образовательных курсов от команды НЦПТИ"
                />
                <meta property="og:image" content={Logo} />
                <meta property="og:url" content={href} />
                <meta property="og:type" content="website" />
            </Helmet>

            <section>
                <h1 className="main_title">События недели</h1>

                {image.map((i) => (
                    <section className="title-image" key={i.id}>
                        <img
                            src={`${baseUrl}${i.file_url}`}
                            alt="Баннер новостей"
                            className="title-image__img-news"
                        />
                    </section>
                ))}

                {mobileImage && (
                    <section className={"title-image__mobile"}>
                        <img
                            src={`${baseUrl}${mobileImage.file_url}`}
                            alt="Мобильный баннер новостей"
                            className={"title-image__img-mobile"}
                        />
                    </section>
                )}
            </section>

            <div className="page">
                {
                    tags.length > 0 && (
                        <section className="tags">
                            {tags.slice(0, mainTags).map((tag) => (
                                <button
                                    key={tag.id}
                                    className={`tags_button ${
                                        selectedTag?.id === tag.id ? "tags_button_active" : ""
                                    }`}
                                    onClick={() => handleTagClick(tag)}
                                >
                                    {tag.name}
                                </button>
                            ))}

                            <button
                                className={`tags_button ${showAll ? "close_button" : ""}`}
                                onClick={() => setShowAll(!showAll)}
                            >
                                {showAll ? "X" : `+${tags.length - mainTags}`}
                            </button>

                            {showAll &&
                                tags.slice(mainTags).map((tag) => (
                                    <button
                                        key={tag.id}
                                        className={`tags_button ${
                                            selectedTag?.id === tag.id ? "tags_button_active" : ""
                                        }`}
                                        onClick={() => handleTagClick(tag)}
                                    >
                                        {tag.name}
                                    </button>
                                ))}
                        </section>
                    )
                }

                {filteredNews.length > 0 ? (
                    filteredNews.map((item) => <OneNews key={item.id} {...item} />)
                ) : (
                    <div className={'not_found'}>
                        <div className={'not_found_block'}>
                            <h2 className={'not_found_block_title'}>Скоро здесь появятся новые новости!</h2>
                        </div>
                    </div>
                )}

                <button
                    className={disabled ? "hide-element" : "button"}
                    disabled={disabled}
                    style={{marginTop: "1rem"}}
                    // onClick={() => setCurrentPage(currentPage + 1)}
                    onClick={() => setCurrentPage(prev => prev + 1)}
                >
                    Показать больше
                </button>
            </div>
        </>
    );
};

export default News;